import { all, call, put, takeLatest } from "redux-saga/effects";
import { NormalizedError } from "services/axios.services/interceptors/commonInterceptors";

import {
  fetchWalletRequest,
  fetchWalletSuccess,
  fetchWalletFailure,
  clearWallet,
} from "./walletActions";
import walletService from "services/api.services/wallet/walletService";
import { logout } from "store/features/user/userActions";

function* handleFetchWallet(): Generator<any, void, any> {
// action: ReturnType<typeof fetchWalletRequest>,
  try {
    // const { userId } = action.payload;
    const response = yield call(walletService.getWalletDetails);
    // console.log({response});

    // const transactionResponse = yield call(UserTransactionService.getUserTransactions,{
    //   pageNumber: 1,
    //   pageSize: 10
    // });

    // console.log({transactionResponse});

    if (!response?.status) {
      yield put(fetchWalletFailure(response?.message || "Wallet fetch failed"));
      return;
    }

    const { walletInfo, transactions } = response;

    yield put(
      fetchWalletSuccess({
        info: walletInfo,
        transactions: transactions || [],
      }),
    );
  } catch (error: any) {
    const err = error as NormalizedError;
    let msg = "Wallet fetch failed";

    if (err?.isNetwork) {
      msg = "Internal server error. Please try again later.";
    } else if (err?.status === 401) {
      msg = "Session expired. Please login again.";
    } else if (err?.status >= 500) {
      msg = "Server error. Please try again.";
    } else if (err?.message) {
      msg = err.message;
    }

    yield put(fetchWalletFailure(msg));
  }
}

// logout par wallet clear
function* handleLogout(): Generator<any, void, any> {
  yield put(clearWallet());
}

export default function* walletSaga() {
  yield all([
    takeLatest(fetchWalletRequest.type, handleFetchWallet),
    takeLatest(logout.type, handleLogout),
  ]);
}
